import {Box, Button, Card, CardContent, Stack, Typography} from "@mui/material";
import {convocatoriaSesionesUrl, globalMaxWidth} from "../GlobalConfigs";
import novedades_background from "../images/la_concepcion_2_gray.jpg";
import React from "react";

export function Novedades() {
    const Item = (props) => {
        const {headerText, contentText, href, buttonText} = props;
        return <Card variant='outlined' sx={{
            borderRadius: '15px', boxShadow: 5, width: 1, maxWidth: globalMaxWidth,
        }}>
            <CardContent>
                <Stack spacing={2} alignItems='center' sx={{
                    m: {lg: 2, xs: 1}
                }}>
                    <Typography variant='h5'>
                        {headerText}
                    </Typography>
                    <Typography variant="body1">
                        {contentText}
                    </Typography>
                    <Button variant='contained' href={href}>
                        {buttonText}
                    </Button>
                </Stack>
            </CardContent>
        </Card>;
    }
    return (<Box
        id ='novedades'
        sx={{
            backgroundImage: `url(${novedades_background})`,
            backgroundSize: '100%',
            backgroundRepeat: 'no-repeat',
            width: 1,
        }}>
        <Stack justifyContent='space-between' alignItems='center' spacing={2} sx={{
            height: 1,
            p: {lg: 4, xs: 1}
        }}>
            <Typography variant='h4' sx={{fontWeight: 700, color: 'primary.main', letterSpacing: 1, textAlign: 'center'}}>
                NOVEDADES
            </Typography>
            <Item
                headerText='¿Vienes al Congreso URSI 2026 en La Laguna?'
                contentText='Consulta nuestra guía con las mejores opciones para llegar a La Laguna y a la sede del congreso: coche, tren, avión, aparcamiento y taxi.'
                href='/simposio/sede#comollegar'
                buttonText='Cómo llegar'
            />

            <Item
                headerText='Enviar una contribución'
                contentText='Ya está abierto el plazo de envío de contribuciones. La fecha límite para la recepción de envíos se ha extendido hasta el 06/04/2026.'
                href='/simposio/comunicaciones'
                buttonText='Enviar'
            />

            {/*<Item*/}
            {/*    headerText='¡Ya está disponible el programa del Congreso URSI 2026!'*/}
            {/*    contentText="Consulta todas las sesiones, horarios y ponencias que tenemos preparadas para ti. ¡Nos vemos muy pronto!"*/}
            {/*    buttonText='Programa'*/}
            {/*/>*/}
            {/*<Item*/}
            {/*    headerText='Listado de alojamientos recomendados para la estancia durante el congreso'*/}
            {/*    buttonText='Ver más'*/}
            {/*/>*/}

            <Item
                headerText='¿Te interesa proponer una sesión especial?'
                buttonText='Descarga la convocatoria'
                href={convocatoriaSesionesUrl}
            />

            <Item
                headerText='Ya está disponible el call for papers'
                buttonText='Más información'
                href={'/simposio/comunicaciones'}
            />

            <Item
                headerText='Propuestas turísticas que no te podrás perder'
                buttonText='Ver más'
                href='https://www.webtenerife.com/'
            />

        </Stack>
    </Box>)
}